
import { defineComponent, nextTick, ref } from 'vue';
import {
  Button,
  Table,
  Avatar,
  Form,
  Radio,
  Input,
  Select,
  TimePicker,
  InputNumber,
} from 'ant-design-vue';
import { PlusOutlined } from '@ant-design/icons-vue';
import sceneDesignMainHeader from '@/components/teacher/sceneConstruct/sceneDesignMainHeader.vue';
import SceneBox from '@/components/teacher/sceneConstruct/sceneBox.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import asynButtonVue from '@/components/asynButton.vue';
import dialogueInfoFn from './js/dialogueInfo';
// import DialogueInfoFn from './js/dialogueInfo';
import dialogueTypeTag from './dialogueTypeTag.vue';
import '@/assets/icons/back2.svg';
import '@/assets/icons/add.svg';

const component = defineComponent({
  name: 'dialogue-info',
  components: {
    SvgIcon,
    SceneBox,
    sceneDesignMainHeader,
    PlusOutlined,
    dialogueTypeTag,
    aButton: asynButtonVue,
    aTable: Table,
    aAvatar: Avatar,
    aForm: Form,
    aFormItem: Form.Item,
    aRadio: Radio,
    aRadioGroup: Radio.Group,
    aInput: Input,
    aInputNumber: InputNumber,
    aTextArea: Input.TextArea,
    aSelect: Select,
    aSelectOption: Select.Option,
    aTimePicker: TimePicker,
  },
  props: {
    headerText: {
      type: String,
      default: '',
    },
    caseId: {
      type: String,
      default: '',
      require: true,
    },
  },
  setup(props, context) {
    const dialogueInfo = ref(null);

    const dialogueNormal = ref();

    const dialogueConditionType = ref();

    const dialogueTriggerTime = ref();

    const dialogueKeyWords = ref();

    const dialogueDeduction = ref();

    const dialogueInfoModule = dialogueInfoFn(context, props.caseId);
    // const dialogueInfoModule = DialogueInfoFn(props.caseId);

    // 编辑表单验证
    const dialogueEditSave = async () => {
      let falgA = false;
      let falgB = false;
      let falgC = false;
      let falgD = false;

      nextTick(async () => {
        await dialogueNormal.value
          .validate()
          .then(() => {
            falgA = true;
          })
          .catch((error: unknown) => {
            console.log(error);
          });

        await dialogueConditionType.value
          .validate()
          .then(() => {
            falgB = true;
          })
          .catch((error: unknown) => {
            console.log(error);
          });

        if (dialogueInfoModule.dialogueEditForm.item.talkType !== 0) {
          await dialogueKeyWords.value
            .validate()
            .then(() => {
              falgC = true;
            })
            .catch((error: unknown) => {
              console.log(error, 'dddd');
            });
        } else {
          falgC = true;
        }

        if (dialogueInfoModule.dialogueEditForm.item.talkType === 2) {
          await dialogueDeduction.value
            .validate()
            .then(() => {
              falgD = true;
            })
            .catch((error: unknown) => {
              console.log(error);
            });
        } else {
          falgD = true;
        }

        console.log(dialogueInfoModule.isShowEdit.value, falgA, falgB, falgC, falgD, '???');
        if (falgA && falgB && falgC && falgD) {
          dialogueInfoModule.dialogueEditSave();
        }
      });
    };

    // 下一步
    function nextStep() {
      context.emit('nextStep');
    }

    const triggerNode = () => dialogueInfo.value;

    return {
      props,
      dialogueInfo,
      dialogueNormal,
      dialogueConditionType,
      dialogueTriggerTime,
      dialogueKeyWords,
      dialogueDeduction,
      dialogueInfoModule,
      nextStep,
      dialogueEditSave,
      triggerNode,
    };
  },
});

export default component;
